import { ReactNode } from "react";
import clsx from "clsx";

interface BrowserFrameProps {
    accent: string;
    children: ReactNode;
    className?: string;
}

export function BrowserFrame({
    accent,
    children,
    className,
}: BrowserFrameProps) {
    return (
        <div
            className={clsx(
                "overflow-hidden rounded-[28px]",
                "border border-border",
                "bg-card",
                "shadow-[0_50px_120px_-40px_rgba(15,23,42,0.35)]",
                className
            )}
        >
            <div
                className="flex items-center justify-between px-5 py-3 text-white"
                style={{
                    background: accent,
                }}
            >
                <div className="flex gap-2">
                    <span className="h-2.5 w-2.5 rounded-full bg-white/40" />
                    <span className="h-2.5 w-2.5 rounded-full bg-white/40" />
                    <span className="h-2.5 w-2.5 rounded-full bg-white/40" />
                </div>

                <div className="h-2 w-36 rounded-full bg-white/30" />

                <div className="flex gap-2">
                    <div className="h-7 w-7 rounded-full bg-white/20" />
                    <div className="h-7 w-7 rounded-full bg-white/20" />
                </div>
            </div>

            {children}
        </div>
    );
}